export default __webpack_public_path__ + "static/media/2.d98d4b22.jpg";